'use client';
import React, { useRef, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function PhotoQuoteForm() {
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [service, setService] = useState('');
  const [fileName, setFileName] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const fileRef = useRef<HTMLInputElement>(null);

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.[0]) setFileName(e.target.files[0].name);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (phone && name) setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-center py-8">
        <div
          className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
          style={{ background: 'rgba(45,95,154,0.15)', border: '1px solid rgba(45,95,154,0.3)' }}
        >
          <Icon name="CheckIcon" size={24} variant="outline" className="text-sapphire" />
        </div>
        <p className="text-lg font-semibold text-off-white mb-2">Request Received!</p>
        <p className="text-sm" style={{ color: '#A8A9AD' }}>
          We&apos;ll reach out to {phone} shortly to confirm your booking.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="mono text-[10px] tracking-widest uppercase block mb-2" style={{ color: 'rgba(168,169,173,0.5)' }}>
          Your Name
        </label>
        <input
          type="text"
          placeholder="First & Last Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full px-4 py-3 rounded-lg text-sm text-off-white placeholder-aluminum/30 outline-none"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(212,212,216,0.12)',
          }}
          onFocus={(e) => (e.currentTarget.style.borderColor = 'rgba(45,95,154,0.5)')}
          onBlur={(e) => (e.currentTarget.style.borderColor = 'rgba(212,212,216,0.12)')}
          required
        />
      </div>

      <div>
        <label className="mono text-[10px] tracking-widest uppercase block mb-2" style={{ color: 'rgba(168,169,173,0.5)' }}>
          Phone Number
        </label>
        <input
          type="tel"
          placeholder="(555) 000-0000"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="w-full px-4 py-3 rounded-lg text-sm text-off-white placeholder-aluminum/30 outline-none"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(212,212,216,0.12)',
          }}
          onFocus={(e) => (e.currentTarget.style.borderColor = 'rgba(45,95,154,0.5)')}
          onBlur={(e) => (e.currentTarget.style.borderColor = 'rgba(212,212,216,0.12)')}
          required
        />
      </div>

      <div>
        <label className="mono text-[10px] tracking-widest uppercase block mb-2" style={{ color: 'rgba(168,169,173,0.5)' }}>
          Service Interested In
        </label>
        <select
          value={service}
          onChange={(e) => setService(e.target.value)}
          className="w-full px-4 py-3 rounded-lg text-sm text-off-white outline-none"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(212,212,216,0.12)',
            colorScheme: 'dark',
          }}
          onFocus={(e) => (e.currentTarget.style.borderColor = 'rgba(45,95,154,0.5)')}
          onBlur={(e) => (e.currentTarget.style.borderColor = 'rgba(212,212,216,0.12)')}
        >
          <option value="" style={{ background: '#1C1C1E' }}>Select a service...</option>
          <option value="interior" style={{ background: '#1C1C1E' }}>Interior Detail — From $120</option>
          <option value="exterior" style={{ background: '#1C1C1E' }}>Exterior Detail — From $100</option>
          <option value="full" style={{ background: '#1C1C1E' }}>Full Detail Package — From $200</option>
          <option value="other" style={{ background: '#1C1C1E' }}>Other / Not Sure</option>
        </select>
      </div>

      <div>
        <label className="mono text-[10px] tracking-widest uppercase block mb-2" style={{ color: 'rgba(168,169,173,0.5)' }}>
          Photo of Your Vehicle (Optional)
        </label>
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          className="w-full px-4 py-5 rounded-lg text-sm flex flex-col items-center gap-2 transition-colors"
          style={{
            background: 'rgba(255,255,255,0.02)',
            border: '2px dashed rgba(212,212,216,0.15)',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.borderColor = 'rgba(45,95,154,0.4)')}
          onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'rgba(212,212,216,0.15)')}
        >
          <Icon name="PhotoIcon" size={22} variant="outline" className="text-aluminum" />
          <span style={{ color: 'rgba(168,169,173,0.5)' }}>
            {fileName || 'Tap to upload a photo'}
          </span>
        </button>
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleFile}
        />
      </div>

      <button
        type="submit"
        className="w-full btn-sapphire py-4 rounded-full mono text-[11px] font-semibold tracking-widest uppercase text-white"
      >
        Send Booking Request
      </button>

      <p className="mono text-[9px] tracking-wider text-center" style={{ color: 'rgba(168,169,173,0.3)' }}>
        We&apos;ll contact you within a few hours to confirm. No spam, ever.
      </p>
    </form>
  );
}